import { useEffect, useState } from "react";
import { api } from "@/lib/apiClient";
import { Users } from "lucide-react";

const tz = (d) => d.toLocaleDateString("sv-SE", { timeZone: "Europe/Istanbul" });
const ranges = () => {
  const now = new Date(), today = tz(now);
  const first = new Date(now); first.setDate(1);
  const prevEnd = new Date(first); prevEnd.setDate(0);
  const prevStart = new Date(prevEnd); prevStart.setDate(1);
  return [["Bu Ay", tz(first), today], ["Geçen Ay", tz(prevStart), tz(prevEnd)]];
};

export const ClubAttendance = ({ refreshKey }) => {
  const [idx, setIdx] = useState(0);
  const [d, setD] = useState(null);
  const R = ranges();
  useEffect(() => {
    const [, start, end] = R[idx];
    api.get("/club/attendance", { params: { start, end } }).then((r) => setD(r.data)).catch(() => setD(null));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idx, refreshKey]);
  if (!d) return null;
  const max = Math.max(1, ...d.rows.map((r) => r.meals));
  return (
    <div className="rounded-xl border border-border bg-card p-4" data-testid="club-attendance">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <h3 className="flex items-center gap-2 font-heading text-base font-semibold"><Users className="h-4 w-4 text-primary" /> Üye Öğün Raporu <span className="text-xs font-normal text-muted-foreground">· {d.total} öğün</span></h3>
        <div className="flex gap-1.5" data-testid="club-att-presets">
          {R.map(([l], i) => (
            <button key={l} type="button" onClick={() => setIdx(i)} data-testid={`club-att-preset-${i}`}
              className={`rounded-full px-3 py-1 text-xs font-semibold transition-colors ${idx === i ? "bg-primary text-primary-foreground" : "bg-muted text-muted-foreground hover:bg-muted/70"}`}>{l}</button>
          ))}
        </div>
      </div>
      <p className="mt-1 text-[11px] text-muted-foreground">{d.start.split("-").reverse().join(".")} – {d.end.split("-").reverse().join(".")} · en düzenli gelen üstte</p>
      <div className="mt-3 space-y-1.5">
        {d.rows.length === 0 && <p className="text-sm text-muted-foreground">Üye yok</p>}
        {d.rows.map((r) => (
          <div key={r.id} className="grid grid-cols-[1fr_auto] items-center gap-3 text-sm sm:grid-cols-[180px_1fr_auto]" data-testid={`club-att-${r.id}`}>
            <span className={`truncate font-medium ${r.active ? "" : "text-muted-foreground line-through"}`}>{r.name}</span>
            <div className="hidden h-2 overflow-hidden rounded-full bg-secondary sm:block"><div className="h-full bg-primary transition-[width]" style={{ width: `${(r.meals / max) * 100}%` }} /></div>
            <span className="text-right text-xs text-muted-foreground">
              <b className={`font-mono text-sm ${r.meals ? "text-foreground" : ""}`}>{r.meals}</b> öğün · {r.days} gün{r.last ? ` · son ${r.last.split("-").reverse().slice(0, 2).join(".")}` : " · hiç gelmedi"} · kalan {r.meals_left}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};
